import {
    Component,
    OnInit,
    Input,
    EventEmitter,
    Output,
    OnChanges
} from '@angular/core';
import { ReviewInterface } from 'src/app/model/reviews/review-interface';
import { ReviewService } from 'src/app/services/review-service/review.service';

@Component({
    selector: 'app-marketplace-rating-extended',
    templateUrl: './marketplace-rating-extended.component.html',
    styleUrls: [
        './marketplace-rating-extended.component.css',
        '../../product-detail-display/product-detail-display.css'
    ],
    standalone: false
})
export class MarketplaceRatingExtendedComponent {
    @Input()
    targetId: number;
    @Input()
    reviewType: number;
    @Input()
    reviews: ReviewInterface[] = [];
    @Input()
    average: number;
    @Input()
    nrOfReviews: number[];
    @Input()
    showWriteReview: boolean;
    @Output()
    averageEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    statisticsEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    reviewEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    reviewCloseEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    reviewOpenEmitter: EventEmitter<any> = new EventEmitter<any>();

    public averageFormatted: string = '';

    constructor() {}

    ngOnChanges() {
        this.formatAverage();
        // this.sortReviews();
    }

    public onReviewsChanged(updatedReviews: ReviewInterface[]) {
        this.reviews = updatedReviews;
        this.formatAverage();
        this.averageEmitter.emit();
        this.statisticsEmitter.emit();
        if (this.targetId !== undefined) {
            this.reviewEmitter.emit();
        }
        // this.sortReviews();
    }

    private formatAverage(): void {
        if (this.average !== undefined && this.average !== null) {
        this.averageFormatted = this.average.toFixed(1).replace('.', ',');
        } else {
        this.averageFormatted = '0,0';
        }
    }
}
